<template>
    <client-page>

        <sub-visual
        sh="Distributor in Korea"
        tabActive="Dupont Vespel®"
        bg="/images/sub/visual/sv3.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container class="mb-lg-42">
                <h2 class="page-tit mb-18 mb-lg-24">
                    <v-img max-width="386" src="/images/logos/vespel.png" alt="Dupont Vespel" class="mx-auto" />
                    <!-- Dupont Vespel® -->
                </h2>
                <h3 class="tit text-center primary--text">Dupont Vespel® 대리점</h3>
            </v-container>

            <sub-bg-image
            src="/images/sub/distributor/dupont/dupont-top-img.png"
            className="h-lg-280px">
                <h3 class="tit font-weight-semibold mb-8 mb-md-50 mb-lg-100">
                    DUPONT은 약 200년 이상의 <br>
                    전통을 가진 미국 화학회사 입니다.
                </h3>
                <p class="page-text color-grey-51">
                    Vespel® 부품은 고성능 솔루션을 제공하기 위해서 고온에서의 <br class="d-none d-md-block">
                    Insulation 역할 및 마모 · 마찰 문제를 해결하기 위한 설계로 제작합니다
                </p>
            </sub-bg-image>

        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="특장점">
                    <v-row>
                        <icon-line-box
                        icon="/images/sub/distributor/dupont/dupont-icon1.png"
                        iconWidth="50"
                        num="01">
                        Vespel® 에서 제작되는 모든 부품의 모양은 <br class="d-none d-lg-block">
                        고객의 요구에 따라 형성됩니다. 
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/dupont/dupont-icon2.png"
                        iconWidth="38"
                        num="02">
                        마모 또는 마찰 문제를 극복하고 고온에서도 견딜 수 있으며 <br class="d-none d-lg-block">
                        가장 가혹한 작동 환경에서도 견딜 수 있습니다.
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/dupont/dupont-icon3.png"
                        iconWidth="50"
                        num="03">
                        Vespel® 부품을 사용하면 생산의 원활한 가동을 <br class="d-none d-lg-block">
                        유지하고 소모품 자재의 사용 간격을 연장 할 수 있습니다. 
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/dupont/dupont-icon4.png"
                        iconWidth="50"
                        num="04">
                        Vespel® 부품의 성능은 단순 실용적일 뿐만 아니라 표준 금속, <br class="d-none d-lg-block">
                        세라믹  및 기타 엔지니어링 플라스틱보다 더 뛰어난 경량 부품을 <br class="d-none d-lg-block">
                        만들 수 있습니다.
                        </icon-line-box>
                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <sub-line-layout tit="Vespel®" class="mb-40 mb-lg-60">
                    <p class="page-text color-grey-51 mb-2 mb-lg-6">
                        Vespel® 은 듀폰상표 3000 종류의 제품군 중 고성능 폴리이미드플라스틱 제품으로 극저온 -196℃ 부터 280℃ <br class="d-none d-lg-block">
                        수준까지 사용하는 분말 소결 재료입니다. 열에 의한 소성변화가 있는 Polymers (PEEK, PAI) 와는 다르게 유리전이온도 <br class="d-none d-lg-block">
                        (재료가 고체에서 액체상태로 변하는 온도)가 없는 차이가 있으며,  Vespel® 플라스틱은 Metals, Ceramics, <br class="d-none d-lg-block">
                        Polymers 재료, 각각에는 없는 특성이 있습니다. 
                    </p>
                    <p class="page-text color-grey-51 mb-30 mb-lg-52">
                        <strong class="font-weight-bold color-point">우주항공, 반도체, 운송장비, 자동차부품, 엔지니어링</strong> 용도로 쓰입니다.
                    </p>
                    <v-row no-gutters>
                        <v-col cols="12" md="6">
                            <table class="client-table client-table-lg w-100 border-md-end">
                                <colgroup>
                                    <col style="width: 25%">
                                    <col style="width: 75%">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="table-inner">등급</div>
                                        </th>
                                        <th>
                                            <div class="table-inner">Properties ( 특성 )</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-1</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 내마모성 ,인장력 우수, 첨가물
                                                    </p>
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 금형에 의한 생산 가능  
                                                    </p>
                                                    <p class="dot-txt-rounded">
                                                        · Low outgassing (반도체)
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-3</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 15% 이황화 몰리브덴 포함
                                                    </p>
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 금형에 의한 생산 불가 
                                                    </p>
                                                    <p class="dot-txt-rounded">
                                                        · 진공 조건에서 사용 (반도체)
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-21</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 저마모성,저마찰력 (자동차) 
                                                    </p>
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 금형에 의한 생산 가능
                                                    </p>
                                                    <p class="dot-txt-rounded">
                                                        ·  15% 그라파이트 포함
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-211</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 저 마찰력, 저마모성(SP-21보다우수)
                                                    </p>
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 금형에 의한 생산 가능
                                                    </p>
                                                    <p class="dot-txt-rounded">
                                                        · 15% 그라파이트, 10%PTFE 포함
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-2515</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 최소 열팽창 SP-21의 4배 (자동차) 
                                                    </p>
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 금형에 의한 생산 가능
                                                    </p>
                                                    <p class="dot-txt-rounded">
                                                        · 10% 그라파이트 포함
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-col>
                        <v-col cols="12" md="6">
                            <table class="client-table client-table--last client-table-lg w-100">
                                <colgroup>
                                    <col style="width: 25%">
                                    <col style="width: 75%">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="table-inner">등급</div>
                                        </th>
                                        <th>
                                            <div class="table-inner">Properties ( 특성 )</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-202</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 전기전도성이 있는 Vespel®소재
                                                    </p>
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 금형에 의한 생산 불가
                                                    </p>
                                                    <p class="dot-txt-rounded">
                                                        · 정전기 제거
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-221</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 금형에 의해서만 생산 가능
                                                    </p>
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 무윤활조건에서 연철(알루미늄, 황동, 동 베어링 등)에 대한 내마모성이 뛰어남
                                                    </p>
                                                    <p class="dot-txt-rounded">
                                                        · 15% 그라파이트, 10%PTFE 포함
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SCP-5000</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 경도, 내화학성, 치수 안정성,첨가물없음
                                                    </p>
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · Low outgassing (반도체)
                                                    </p>
                                                    <p class="dot-txt-rounded">
                                                        · 금형에 의한 생산 불가 
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SCP-50094</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 내화학성 및 내열산화성 (자동차) 
                                                    </p>
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 그라파이트 저 충진 폴리이미드
                                                    </p>
                                                    <p class="dot-txt-rounded">
                                                        · 금형에 의한 생산 가능
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SCP-5050</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 강철과 유사한 열팽창계수(우주항공)
                                                    </p>
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">
                                                        · 그라파이트 고 충진 폴리이미드
                                                    </p>
                                                    <p class="dot-txt-rounded">
                                                        · 금형에 의한 생산 가능
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-col>
                    </v-row>
                </sub-line-layout>

                <inquiry
                src="/images/sub/distributor/dupont/dupont-img1.png"
                name="유 동현"
                tel="031-765-2268"
                mail="davidyoo@ist-co.kr"
                fax="031-765-2389"
                link="https://www.dupont.com/vespel.html"
                linkBg="/images/sub/distributor/dupont/dupont-img2.png">
                </inquiry>

            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/ko/sub/sub-line-layout.vue";
import SubBgImage from "@/components/client/ko/sub/sub-bg-image.vue";
import IconLineBox from "@/components/client/ko/sub/sub-icon-line-box.vue";
import Inquiry from "@/components/client/ko/sub/sub-inquiry.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubBgImage,
        IconLineBox,
        Inquiry,
    },
};
</script>

<style lang="scss" scoped>
</style>